<template>
  <div class="page-content">
    <!-- 顶部 top -->
    <!-- <div class="tap-title">
      <span>用户管理</span>
    </div> -->

    <!-- 角色搜索以及添加栏目 -->
    <el-row  class="product-menu" type="flex" justify="end">
      <el-col>
         <el-button type="primary" class="first-btn" @click="addBtn">添加按钮</el-button>
      </el-col>
      <el-col :span="6">
        <!-- <el-checkbox v-model="checked" class="showOnline">只显示在线用户</el-checkbox> -->
        <el-input placeholder="请输入按钮名称" v-model.trim="btnsName" class="input-with-select" >
          <el-button slot="append" icon="el-icon-search" @click="sel"></el-button>
        </el-input>
      </el-col>
    </el-row>

    <!-- 数据展示区域 -->
    <div class="dataList">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        :cell-style="acellStyle"
        :header-cell-style="headCellStyle"
        style="width: 100%">
        <el-table-column
         prop="buttonName"
          label="按钮名称">
        </el-table-column>
        <el-table-column
         prop="buttonValue"
          label="按钮标识 ">
        </el-table-column>
        <el-table-column
         prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
         prop="createUser"
          label="创建者">
        </el-table-column>
        <el-table-column
          label="操作"
          >
          <template slot-scope="scope">
            <div class="opreationBtn">
              <span class="edit" @click="handlerClick('edit',scope.row)" >编辑</span>
              <span class="check" @click="handlerClick('assign',scope.row)">分配权限</span>
              <span class="del" v-if="scope.row.delete===false" @click="handlerClick('del',scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <paging :total="total" @changePage="changePage"/>
    <!-- 新增用户dialog -->
    <addDialog v-if="addDialogVisible" :addDialogVisible="addDialogVisible" @closeAddDialog="closeAddDialog"/>
    <!-- 编辑用户dialog -->
    <editDialog v-if="editDialogVisible" :editDialogVisible="editDialogVisible" :btnId="btnId" @closeEditDialog="closeEditDialog" :status="status"/>
    <!-- 分配用户dialog -->
    <assignRoleDialog v-if="assignDialogVisible" :assignDialogVisible="assignDialogVisible" :btnId="btnId" @closeAssignDialog="closeAssignDialog"/>
  </div>
</template>

<script>
import addDialog from '@/components/buttonManager/addDialog'
import editDialog from '@/components/buttonManager/editDialog'
import assignRoleDialog from '@/components/buttonManager/assignDialog'
import paging from '@/components/paging'
import { btnsList, deleteBtns } from '@/api/buttons'
export default {
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        page: 1,
        limit: 10
      },
      // ------------
      tableData: [],
      // checked: false,
      btnsName: '',
      // 设置表格的样式
      acellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' },
      addDialogVisible: false,
      // viewDialogVisible: false,
      // viewData: null,
      editDialogVisible: false, // 编辑或者查看
      status: false,
      assignDialogVisible: false, // 分配角色
      btnId: ''
    }
  },
  components: {
    addDialog,
    editDialog,
    assignRoleDialog,
    paging
  },
  created () {
    this.getBtnsList()
  },
  methods: {
    sel () {
      this.listQuery.page = 1
      this.getBtnsList()
    },
    getBtnsList () {
      const params = {
        buttonName: this.btnsName,
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit
      }
      btnsList(params).then((res) => {
        const resData = res.data.data
        this.total = resData.total
        this.tableData = resData.list
        this.tableData.forEach((item) => {
          if (item.online === true) {
            item.online = '在线'
          } else {
            item.online = '离线'
          }
          if (item.userAccStatus === true) {
            item.userAccStatus = '已启用'
          } else {
            item.userAccStatus = '已禁用'
          }
        })
      })
    },
    addBtn () {
      this.addDialogVisible = true
    },
    closeAddDialog (val) {
      this.addDialogVisible = false
      if (val) {
        this.getBtnsList()
      }
    },
    closeEditDialog (val) {
      this.editDialogVisible = false
      if (val) {
        this.getBtnsList()
      }
    },
    closeAssignDialog (val) {
      this.assignDialogVisible = false
      if (val) {
        this.getBtnsList()
      }
    },
    handlerClick (sty, row) {
      switch (sty) {
        case 'edit':
          this.btnId = row.buttonId
          this.status = false
          this.editDialogVisible = true
          break
        case 'assign':
          this.btnId = row.buttonId
          this.assignDialogVisible = true
          break
        case 'del':
          this.$confirm('确定删除此记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            const id = row.buttonId
            deleteBtns(id).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.getBtnsList()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '删除取消'
            })
          })
          break
        default:
          break
      }
    },
    // 分页管理
    changePage (val) {
      this.listQuery = val
      this.getBtnsList()
    }
  }
}
</script>

<style lang="less" scoped>
  .page-content{
     .tap-title{
      margin-bottom: 30px;
      padding-left: 10px;
      display: flex;
      border-left: 5px solid skyblue ;
      font-size: 16px;
    }
    .product-menu{
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .showOnline{
        margin-right: 20px;
      }
      .is-justify-end{
        align-items: center;
      }
      .left{
        span{
          margin-right: 20px;
          font-size: 20px;
          font-weight: 600;
        }
        .first-btn{
          margin-right: 10px;
        }
        .refalsh{
          margin-right: 20px;
        }
      }

    }

    .dataList{
      background-color: white;
      margin-bottom: 20px;
      .cell{
        text-align: center;
      }
      .opreationBtn{
        .check,.edit{
          color: #35a6df;
          cursor: pointer;
        }
        .del,.stop{
          color: red;
          cursor: pointer;
        }
        span{
          margin-left: 20px;
        }
      }
      .onlineStatus{
        .online{
          color: #138c4b;
        }
        .offline{
          color: red
        }
        span{
          margin-left: 20px;
        }
      }
      .showAll{
        display: flex;
        align-items: center;
        span{
          color: #f0bd95;
        }
      }
      .dataListOperation{
        padding:20px;
      }
    }
}
</style>
